export const ultimasNoticias = [
    {
        "imagen" : "./assets/imgs/ultimas_noticias/11_04.jpg",
        "url" : "https://www.facebook.com/Strabajohgo/posts/pfbid0E4hRRxKSyCJqSdgWMBuh1XFJ9dxDutXC7wPuqb8aFPAJR3jBS2aZtZmUezrL9ZYRl",
        "titulo" : "Conoce la oferta de trabajo del #PeriódicoDigitalDelEmpleo en su edición de la primera quincena de abril",
        "fecha" : "11 de abril del 2025"
    },{
        "imagen" : "./assets/imgs/ultimas_noticias/11_04_2.jpg",
        "url" : "https://www.facebook.com/Strabajohgo/posts/1005599275005743?ref=embed_post",
        "titulo" : "La #ProcuraduríaEstatalDeLaDefensaDelTrabajo ofrece asesoría laboral gratuita y representación en caso de iniciar un proceso jurídico ante el #TribunalLaboral.",
        "fecha" : "11 de abril del 2025"
    },{
        "imagen" : "./assets/imgs/ultimas_noticias/11_04_3.jpg",
        "url" : "https://www.facebook.com/Strabajohgo/posts/1004962775069393?ref=embed_post",
        "titulo" : "Participamos en #LasRutasDeLaTransformación en el municipio de #Tlanalapa, para acercamos oportunidades de crecimiento en cada rincón de la entidad",
        "fecha" : "10 de abril del 2025"
    },{
        "imagen" : "./assets/imgs/ultimas_noticias/11_04_4.jpg",
        "url" : "https://www.facebook.com/Strabajohgo/posts/1004297281802609?ref=embed_post",
        "titulo" : "Con el firme compromiso de fortalecer la seguridad y el bienestar de las y los hidalguenses, en representación del titular de la #STPSH",
        "fecha" : "09 de abril del 2025"
    },{
        "imagen" : "./assets/imgs/ultimas_noticias/11_04_5.jpg",
        "url" : "https://www.facebook.com/Strabajohgo/posts/1004289715136699?ref=embed_post",
        "titulo" : "En el municipio de Presidencia Municipal Tepeapulco 2024-2027 se realizó un encuentro con el sector empresarial en el que representantes de la #DirecciónGeneraldelTrabajo",
        "fecha" : "09 de abril del 2025"
    },

]